import { Sun, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-sunlit-ink text-sunlit-ivory" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-sunlit-gold/20 ring-1 ring-sunlit-gold/50">
                <Sun className="h-5 w-5 text-sunlit-gold" />
              </span>
              <span className="font-serif-display text-2xl">
                Sunlit <span className="italic text-sunlit-gold">Happiness</span>
              </span>
            </div>
            <p className="mt-5 text-sm text-sunlit-ivory/70 leading-relaxed max-w-sm">
              A small, sincere practice in happiness coaching by Dr. Vrinda Jayaram S — held with care,
              never as therapy.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-sunlit-ivory/60">Reach out</p>
            <ul className="mt-5 space-y-3 text-sm text-sunlit-ivory/85">
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-sunlit-gold" />
                <a href="mailto:jayaramvrindajayaram@gmail.com" data-testid="footer-email">jayaramvrindajayaram@gmail.com</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-sunlit-gold" />
                <span data-testid="footer-phone">By request, after first call</span>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-sunlit-ivory/60">A small note</p>
            <p className="mt-5 text-sm text-sunlit-ivory/70 leading-relaxed">
              This is coaching, not clinical therapy. If you are in crisis, please approach a licenced mental-health professional.
            </p>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="text-xs text-sunlit-ivory/50">
            © {new Date().getFullYear()} Dr. Vrinda Jayaram S · Crafted with love and care.
          </p>
          <p className="text-xs text-sunlit-ivory/50 font-serif-display italic">
            "Choose Happiness. Then practice it."
          </p>
        </div>
      </div>
    </footer>
  );
}
